module.exports = __webpack_public_path__ + "static/media/Repeat.319fa8b4.svg";